<!-- .block-slideshow -->
<div class="block-slideshow block" *ngIf="!isServer"
    [ngClass]="{'block-slideshow--layout--full': !withDepartments, 'block-slideshow--layout--with-departments': withDepartments, 'block-slideshow--hero': hero}"
    [style.background]="slideBackgroundColor" style="transition: 0.5s;">
    <div class="container">
        <div class="row">
            <div *ngIf="withDepartments" class="col-2 d-md-block d-lg-block d-none d-none" appDepartmentsArea></div>
            <div  class="col-12 col-lg-10">
                <div class="block-slideshow__body">
                    <owl-carousel-o *ngIf="slides?.length"  [options]="options" appOwlPreventClick appTouchSlop (changed)="caroChanged($event)">
                        <ng-template *ngFor="let slide of slides" carouselSlide>
                            <a class="block-slideshow__slide" [routerLink]="slide.link" appClick>
                                <img fetchpriority="high" class="block-slideshow__slide-image block-slideshow__slide-image--desktop img-fluid"
                                    [src]="withDepartments ? slide.image_classic : slide.image_full" [alt]="slide.title"/>
                                <img fetchpriority="high" class="block-slideshow__slide-image block-slideshow__slide-image--mobile"
                                    [src]="slide.image_mobile"
                                    [alt]="slide.title"/>
                                <img *ngIf="slide.image_mobile_sm" fetchpriority="high" class="block-slideshow__slide-image block-slideshow__slide-image--mobile-sm"
                                    [src]="slide.image_mobile_sm"
                                    [alt]="slide.title"/>
                                <!-- The owner's words on the slide (the "home.hero" fragment): the page's heading on the first,
                                     a sentence and its button on each of the others. -->
                                <ng-container *ngIf="hero">
                                    <ng-container *ngTemplateOutlet="content; context: { $implicit: slide }"></ng-container>
                                </ng-container>
                            </a>
                        </ng-template>
                    </owl-carousel-o>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- .block-slideshow / end -->
<div class="block-slideshow block" *ngIf="isServer"
    [ngClass]="{'block-slideshow--layout--full': !withDepartments, 'block-slideshow--layout--with-departments': withDepartments, 'block-slideshow--hero block-slideshow--still': hero}"
    [style.background]="slideBackgroundColor" style="transition: 0.5s;">
    <div class="container">
        <div class="row">
            <div *ngIf="withDepartments" class="col-3 d-md-block d-lg-block d-none" appDepartmentsArea style="max-width: 270px;"></div>
            <div class="col-12" [ngClass]="{'col-lg-12': !withDepartments, 'col-lg-9': withDepartments}">
                <div class="block-slideshow__body">
                    <a class="block-slideshow__slide" [routerLink]="slideOne?.link" appClick>
                        <img fetchpriority="high" class="block-slideshow__slide-image block-slideshow__slide-image--desktop"
                            [src]="withDepartments ? slideOne?.image_classic : slideOne?.image_full" [alt]="slideOne?.title"/>
                        <img fetchpriority="high" class="block-slideshow__slide-image block-slideshow__slide-image--mobile"
                            [src]="slideOne?.image_mobile"
                            [alt]="slideOne?.title"/>
                            <ng-container *ngIf="hero; else placeholder">
                                <ng-container *ngTemplateOutlet="content; context: { $implicit: slideOne }"></ng-container>
                            </ng-container>
                            <ng-template #placeholder>
                            <div class="block-slideshow__slide-content" [style.color]="slideOne?.iswhite ? '#fff' : ''">
                                <h1 style="max-width: 90%;" class="block-slideshow__slide-title" [innerHTML]="sanitizer.bypassSecurityTrustHtml(slideOne?.title)"></h1>
                                <h2 class="block-slideshow__slide-text" [innerHTML]="sanitizer.bypassSecurityTrustHtml(slideOne?.text)" style="font-size: 16px; font-weight: normal;"></h2>
                                <div class="block-slideshow__slide-button">
                                    <span class="btn btn-primary">{{ 'buy-now' | t:'Buy Now' }}</span>
                                </div>
                            </div>
                            </ng-template>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- A hero slide's words: the heading (the page's H1) and its line, or a sentence and its button. Text, not HTML. -->
<ng-template #content let-slide>
    <div class="block-slideshow__slide-content block-slideshow__slide-content--hero" [style.color]="slide.iswhite ? '#fff' : ''">
        <h1 *ngIf="slide.heading" class="block-slideshow__slide-title">{{ slide.title }}</h1>
        <div *ngIf="!slide.heading" class="block-slideshow__slide-title">{{ slide.title }}</div>
        <p *ngIf="slide.text" class="block-slideshow__slide-text">{{ slide.text }}</p>
        <div class="block-slideshow__slide-button" *ngIf="slide.button">
            <span class="btn btn-primary block-slideshow__cta">{{ slide.button }}</span>
        </div>
    </div>
</ng-template>
